/**
 * Spanish translations
 */
import type { Translations } from "./en";

export const es: Translations = {
  errors: {
    roomNoEmail: "Esta sala no tiene una dirección de correo electrónico configurada. Contacte a su administrador.",
    roomAlreadyBooked: "Esta sala ya está reservada para este horario. Pruebe otra sala.",
    bookingFailed: "No se pudo agregar la sala al evento",
    networkError: "Verifique su conexión a Internet e inténtelo de nuevo. Si el problema persiste, intente reconectarse.",
    authError: "Por favor, inicie sesión de nuevo.",
    authRequired: "Autenticación requerida",
    authFailed: "Error de autenticación. Inténtelo de nuevo.",
    accountNotFound: "No hay ninguna cuenta Deskare asociada al correo {email}. Contacte a su administrador.",
    userCancelled: "Se canceló el inicio de sesión. Inténtelo de nuevo cuando esté listo.",
    accountNotSupported: "Este tipo de cuenta no es compatible. Inicie sesión con una cuenta Microsoft 365 profesional o educativa.",
    popupBlocked: "El navegador bloqueó la ventana de inicio de sesión. Permita las ventanas emergentes para este complemento y reintente.",
    consentRequired: "Se requiere el consentimiento del administrador. Pida a su administrador que apruebe este complemento.",
    apiNotAvailable: "El servicio de identidad de Microsoft no está disponible en esta versión de Outlook. Actualice Outlook y reintente.",
    validationError: "Verifique sus datos e inténtelo de nuevo.",
    unknownError: "Se ha producido un error inesperado.",
    outlookContextUnavailable: "El contexto de Office no está disponible",
    outlookNoAppointment: "No hay cita activa",
    outlookCannotUpdateLocation: "No se puede actualizar la ubicación",
    outlookCannotAddAttendee: "No se puede agregar el participante",
    outlookCannotStoreData: "No se pueden guardar los datos",
  },
  success: {
    roomAdded: "La sala se ha agregado a su evento.",
  },
  ui: {
    addRoom: "Agregar sala",
    addingRoom: "Agregando sala...",
    addAnotherRoom: "Agregar otra sala",
    done: "Listo",
    close: "Cerrar",
    viewOtherRooms: "Ver otras salas",
    searchRooms: "Buscar salas",
    reconnect: "Reconectar",
    roomFree: "Disponible",
    roomBooked: "Reservada",
    roomAddedTitle: "Sala agregada!",
    roomAddedDescription: "La sala se ha agregado a su evento y se ha establecido como ubicación.",
    loadingAppointment: "Cargando detalles de la cita...",
    filters: "Filtros",
    minCapacity: "Capacidad mínima",
    equipment: "Equipamiento",
    noRoomsFound: "No se encontraron salas",
    adjustFilters: "Intente ajustar sus filtros",
    roomFound: "sala encontrada",
    roomsFound: "salas encontradas",
    capacity: "Capacidad",
    attendee: "participante",
    attendees: "participantes",
    tabsRooms: "Salas",
    tabsInsights: "Contexto",
    tabsShortlist: "Favoritos",
    meetingSummary: "Resumen de la reunión",
    insightsTitle: "Preparar la reunión",
    recommendedRooms: "Salas recomendadas para este horario",
    timeWindow: "Franja horaria",
    noShortlist: "Inicie una búsqueda para preparar una selección",
    recommendedForYou: "Recomendado para usted",
    refineSearch: "Refinar búsqueda",
    people: "personas",
    allRooms: "Todas las salas",
    loadingRooms: "Cargando salas...",
    tryAdjustFilters: "Intente ajustar los filtros",
    noSubject: "Sin asunto",
    organizer: "Organizador",
    you: "Usted",
    location: "Ubicación",
    more: "más",
    confirmed: "Confirmada",
    changeRoom: "Cambiar sala",
    cancelReservation: "Cancelar reserva",
    loadingReservations: "Cargando reservas...",
    errorLoadingReservations: "Error al cargar las reservas",
    currentMeetingReservation: "Reserva de la reunión actual",
    noReservations: "Sin reservas",
    noReservationsDescription: "No tiene ninguna sala reservada para esta reunión",
    tabsBook: "Reservar",
    tabsReservations: "Mis reservas",
    cancel: "Cancelar",
    allOfficesLabel: "Todas las oficinas",
    office: "Oficina",
    signOut: "Cerrar sesión",
    signIn: "Iniciar sesión",
    signedOutMessage: "Has cerrado sesión.",
  },
  errorContext: {
    conflict: "Esta sala ya está reservada para este horario. Pruebe otra sala.",
    network: "Verifique su conexión a Internet e inténtelo de nuevo. Si el problema persiste, intente reconectarse.",
    auth: "Por favor, inicie sesión de nuevo.",
    validation: "Verifique sus datos e inténtelo de nuevo.",
  },
};
